import { createAction, props } from '@ngrx/store';

import { Address } from '@api/address/models/address.models';
import { ShippingMethod } from '@api/shipping/models/shipping.model';
import { ShippingPromotionsData, ShippingPromotionsOverData } from '@features/shipping/shipping-promotions';

export const ShippingActions = {
    LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS: '[shipping] LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS',
    LOAD_SHIPPING_METHODS: '[shipping] LOAD_SHIPPING_METHODS',
    LOAD_SHIPPING_METHODS_SUCCESS: '[shipping] LOAD_SHIPPING_METHODS_SUCCESS',
    LOAD_SHIPPING_METHODS_ERROR: '[shipping] LOAD_SHIPPING_METHODS_ERROR',
    SET_SELECTED_SHIPPING_METHOD: '[shipping] SET_SELECTED_SHIPPING_METHOD',
    SET_USER_ADDRESS_PICKUP: '[shipping] Dirección de usuario seleccionada para el envío a tienda',
    SEND_CHECKOUT_SHIPPING: '[shipping] SEND_CHECKOUT_SHIPPING',
    SEND_CHECKOUT_SHIPPING_SUCCESS: '[shipping] SEND_CHECKOUT_SHIPPING_SUCCESS',
    SEND_CHECKOUT_SHIPPING_ERROR: '[shipping] SEND_CHECKOUT_SHIPPING_ERROR',
    LOAD_SHIPPING_PROMOTIONS: '[shipping] LOAD_SHIPPING_PROMOTIONS',
    LOAD_SHIPPING_PROMOTIONS_SUCCESS: '[shipping] LOAD_SHIPPING_PROMOTIONS_SUCCESS',
    LOAD_SHIPPING_PROMOTIONS_ERROR: '[shipping] LOAD_SHIPPING_PROMOTIONS_ERROR',
    SET_FREE_SHIPPING_OVER_PROMO: '[shipping] SET_FREE_SHIPPING_OVER_PROMO',
    ENABLE_FAST_SINT: '[shipping] ENABLE_FAST_SINT',
    DISABLE_FAST_SINT: '[shipping] DISABLE_FAST_SINT',
    SET_FAST_SINT: '[shipping] SET_FAST_SINT',
};

export const LoadShippingMethodRequirementsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS,
);

export const LoadShippingMethods = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS,
);

export const LoadShippingMethodsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_SUCCESS,
    props<{ values: ShippingMethod[] }>()
);

export const LoadShippingMethodsError = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_ERROR,
    props<{ error: any }>()
);

export const SetUserAddressForPickup = createAction(ShippingActions.SET_USER_ADDRESS_PICKUP, props<{ payload: Address }>());

export const SetSelectedShippingMethod = createAction(
    ShippingActions.SET_SELECTED_SHIPPING_METHOD,
    props<{ selectedShippingMethod: ShippingMethod }>()
);

export const SendCheckoutShipping = createAction(ShippingActions.SEND_CHECKOUT_SHIPPING);
export const SendCheckoutShippingSuccess = createAction(ShippingActions.SEND_CHECKOUT_SHIPPING_SUCCESS);
export const SendCheckoutShippingError = createAction(
    ShippingActions.SEND_CHECKOUT_SHIPPING_ERROR,
    props<{ error: any; selectedMethod?: ShippingMethod }>()
);

export const SetFreeShippingOverPromo = createAction(
    ShippingActions.SET_FREE_SHIPPING_OVER_PROMO,
    props<{ payload: ShippingPromotionsOverData }>()
);

export const LoadShippingPromotions = createAction(ShippingActions.LOAD_SHIPPING_PROMOTIONS);
export const LoadShippingPromotionsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_PROMOTIONS_SUCCESS,
    props<{ payload: ShippingPromotionsData }>()
);
export const LoadShippingPromotionsError = createAction(ShippingActions.LOAD_SHIPPING_PROMOTIONS_ERROR);
